import styled from 'styled-components/';
import AppCSS from '../../../../utils/styled';
import { UIView } from '../../../../utils/styled/styled';

export const Components = {
  Event: styled.div`
    border-left: 4px solid ${(p) => AppCSS.colors.blue};
    padding: 4px 8px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${AppCSS.colors.greys.light};
  `,
  EventHeader: styled(UIView)`
    width: 100%;
    gap: 4px;
  `,
  EventIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
  `,
  EventTitle: styled.div`
    ${AppCSS.fonts.label10Bold};
    color: ${AppCSS.colors?.black};
    margin-top: 1px;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    overflow: hidden;
  `,
  EventSubtitle: styled.div`
    margin-top: 3px;
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.blues.veryDark};
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    overflow: hidden;
  `,
};
